import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDomainSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteDomainSubscription = { __typename?: 'Subscription', deleteDomain: { __typename?: 'DeleteDomainStatus', progress: number, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };


export const DeleteDomainDocument = gql`
    subscription DeleteDomain($id: Int!) {
  deleteDomain(id: $id) {
    progress
    errors {
      location
      context
      type
    }
  }
}
    `;

/**
 * __useDeleteDomainSubscription__
 *
 * To run a query within a React component, call `useDeleteDomainSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeleteDomainSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteDomainSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDomainSubscription(baseOptions: Apollo.SubscriptionHookOptions<DeleteDomainSubscription, DeleteDomainSubscriptionVariables> & ({ variables: DeleteDomainSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeleteDomainSubscription, DeleteDomainSubscriptionVariables>(DeleteDomainDocument, options);
      }
export type DeleteDomainSubscriptionHookResult = ReturnType<typeof useDeleteDomainSubscription>;
export type DeleteDomainSubscriptionResult = Apollo.SubscriptionResult<DeleteDomainSubscription>;